/**
 * One-time claim token returned by checkout, kept in sessionStorage (this tab only, survives
 * the Stripe redirect) until the confirmation screen exchanges it for a session.
 */
const key = (orderId: string) => `gg_claim:${orderId}`;

export function saveOrderClaim(orderId: string, token: string): void {
  try {
    sessionStorage.setItem(key(orderId), token);
  } catch {
    // No storage: the buyer logs in by magic link instead.
  }
}

export function readOrderClaim(orderId: string): string | null {
  try {
    return sessionStorage.getItem(key(orderId));
  } catch {
    return null;
  }
}

export function clearOrderClaim(orderId: string): void {
  try {
    sessionStorage.removeItem(key(orderId));
  } catch {
    // ignore
  }
}
